import React, { useRef } from "react";
import { CHAT_COLUMN_CLASS } from "../constants/chatLayout";
import type { ToolStep } from "../hooks/useChatStreaming";
import { AgentStepTimeline, type AgentStep } from "./AgentStepTimeline";

interface ToolProgressStepsProps {
  steps: ToolStep[];
}

/**
 * Agent chat's live steps, drawn with the same AgentStepTimeline the
 * onboarding chat uses, so every agent shows its work the same way. The hook
 * tracks running/done; the times are noted here, as each step is first seen
 * running and then done.
 */
export const ToolProgressSteps: React.FC<ToolProgressStepsProps> = ({ steps }) => {
  const times = useRef<Record<string, { startedAt: number; endedAt?: number }>>({});
  if (steps.length === 0) return null;

  const now = Date.now();
  const timeline: AgentStep[] = steps.map((s, i) => {
    const id = `${i}-${s.tool}`;
    const t = (times.current[id] ??= { startedAt: now });
    if (s.state === "done" && t.endedAt === undefined) t.endedAt = now;
    return { id, tool: s.tool, status: s.state === "done" ? "done" : "running", startedAt: t.startedAt, endedAt: t.endedAt };
  });

  return (
    <div className={`${CHAT_COLUMN_CLASS} animate-fadeIn`}>
      <AgentStepTimeline steps={timeline} />
    </div>
  );
};
